// StepData — Phase 5 step 6 (V1 scaffold).
// Choose how to bootstrap data: clean slate, import from spreadsheet,
// or carry-over from a sister tenant. V1 only records the *intent*;
// the importer itself is a future iteration.
import React, { useState, useEffect } from 'react';
import { Button } from '../../../components/ui/button';
import { Database, ChevronRight, FileSpreadsheet, Sparkles, Copy } from 'lucide-react';

const MODES = [
  { id: 'fresh',  label: 'Start with a clean slate', desc: 'Empty books — perfect for a brand-new company.', icon: Sparkles },
  { id: 'import', label: 'Import from spreadsheet',  desc: 'Upload customers / suppliers / opening balances via CSV (later).', icon: FileSpreadsheet },
  { id: 'copy',   label: 'Copy from existing tenant', desc: 'Clone chart-of-accounts + settings from another company (later).', icon: Copy },
];

export default function StepData({ initialData, onSubmit, busy }) {
  const [mode, setMode] = useState('fresh');
  useEffect(() => {
    if (initialData?.mode) {
      const h = setTimeout(() => setMode(initialData.mode), 0);
      return () => clearTimeout(h);
    }
  }, [initialData]);

  return (
    <div data-testid="step-data" className="space-y-5">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-indigo-50 text-indigo-700"><Database size={18} /></div>
        <div>
          <h2 className="text-lg font-bold text-slate-900">Initial data</h2>
          <p className="text-sm text-slate-500 mt-0.5">How would you like to bootstrap the new tenant&apos;s books?</p>
        </div>
      </div>

      <div className="space-y-2">
        {MODES.map((m) => {
          const Icon = m.icon;
          const on = mode === m.id;
          return (
            <button
              type="button"
              key={m.id}
              data-testid={`data-mode-${m.id}`}
              onClick={() => setMode(m.id)}
              className={`w-full text-left px-4 py-3 rounded-lg border flex items-start gap-3 transition ${
                on ? 'border-indigo-500 bg-indigo-50' : 'border-slate-200 bg-white hover:border-slate-300'
              }`}
            >
              <div className={`p-2 rounded ${on ? 'bg-indigo-100 text-indigo-700' : 'bg-slate-100 text-slate-500'}`}>
                <Icon size={16} />
              </div>
              <div className="flex-1">
                <div className="text-sm font-semibold text-slate-900">{m.label}</div>
                <div className="text-xs text-slate-500">{m.desc}</div>
              </div>
              {on && (
                <span className="text-[10px] uppercase tracking-wider font-bold text-emerald-700 self-center">Selected</span>
              )}
            </button>
          );
        })}
      </div>

      <div className="flex justify-end">
        <Button
          onClick={() => onSubmit({ mode })}
          disabled={busy}
          data-testid="data-save-btn"
          className="bg-indigo-600 hover:bg-indigo-700 text-white"
        >
          Save & continue <ChevronRight size={14} className="ml-1.5" />
        </Button>
      </div>
    </div>
  );
}
